export function throttle(fn, wait) {
  let time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  };
}

export function getToday() {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  const yyyy = today.getFullYear();
  if (dd < 10)
    dd = '0' + dd;
  if (mm < 10)
    mm = '0' + mm;
  return yyyy + '-' + mm + '-' + dd;
}

export function setLatestDate(previousDate, newDate) {
  if (newDate == '')
    return newDate;
  if (previousDate == '')
    return previousDate;
  if (newDate > previousDate)
    return newDate;
  return previousDate;
}

export function scrollToAndFocusOnElement(selector) {
  const element = document.querySelector(selector);

  if (!element)
    return;

  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo({
    top: elementPosition,
    behavior: 'smooth'
  });

  setTimeout(() => {
    element.focus();
  }, 500);
}

// export function deepest (subMenu, select) {
//   return [].slice.call(subMenu.querySelectorAll(select)).reduce(
//     function (deepest, el) {
//       // eslint-disable-next-line no-var
//       for (var d = 0, e = el; e !== subMenu; d++, e = e.parentNode);
//       return d > deepest.d ? { d: d, el: el } : deepest;
//     }, { d: 0, el: subMenu }).el;
// }

/**
 * Finds the deepest matching element in a given subMenu based on the provided selector.
 *
 * @param {Element} subMenu - The subMenu element to search within.
 * @param {string} select - The CSS selector to match elements.
 * @returns {Element} The deepest matching element in the subMenu.
 */
export function deepest(subMenu, select) {
  const matchingElementsArray = [...subMenu.querySelectorAll(select)];
  const deepestElement = findDeepestElement(matchingElementsArray, subMenu);

  return deepestElement;
}

/**
 * Calculates the depth of a given element in relation to the subMenu.
 *
 * @param {Element} element - The element to calculate the depth for.
 * @param {Element} subMenu - The subMenu element to search within.
 * @returns {number} The depth of the given element in relation to the subMenu.
 */
function calculateDepth(element, subMenu) {
  let depth = 0;
  let currentElement = element;
  while (currentElement !== subMenu) {
    depth++;
    currentElement = currentElement.parentNode;
  }
  return depth;
}

/**
 * Finds the deepest element from the matching elements array in relation to the subMenu.
 *
 * @param {Array<Element>} matchingElementsArray - The array of matching elements.
 * @param {Element} subMenu - The subMenu element to search within.
 * @returns {Element} The deepest element in relation to the subMenu.
 */
function findDeepestElement(matchingElementsArray, subMenu) {
  const reducer = (deepest, element) => {
    const depth = calculateDepth(element, subMenu);
    return depth > deepest.depth ? { depth: depth, element: element } : deepest;
  };

  const deepestElement = matchingElementsArray.reduce(reducer, { depth: 0, element: subMenu });

  return deepestElement.element;
}

export function phoneNumberRegexpCheck(phoneString) {
  const regex = /^[+-. 0-9]{3,}$/;
  if (regex.test(phoneString)) {
    return true;
  } else {
    return false;
  }
}

export function getDuplicateArrayElements(arr) {
  return arr.filter(function(item, index) {
    return (arr.indexOf(item) < index);
  });
}

/**
 * @description Sätter en klass på ett htmlelement för att sen ta bort den efter en viss tid
 * @param {HTMLElement} el
 * @param {number} time
 * @param {string} classToAdd
 */
export function addClassAndRemoveElement(el, time, classToAdd = 'wl-removing-el') {
  if (!(el instanceof HTMLElement) || isNaN(time))
    return;

  el.classList.add(classToAdd);

  setTimeout(() => {
    el.remove();
  }, time);
}

export function siteLangIsSwedish() {
  if (jQuery('html').attr('lang') === 'sv-SE')
    return true;

  return false;
}

export function arrayHasCommonElement(arr1, arr2) {
  return arr1.some(item => arr2.includes(item));
}

/**
 * Sätt en cookie på samma sätt som setcookie() i PHP
 *
 * @param {string} name
 * @param {string} value
 * @param {number} [days] - Antal dagar tills cookien förfaller. Om det inte anges blir cookien en sessionscookie och förfaller när webbläsaren stängs.
 * @param {string} [path] - Sökvägen inom domänen för vilken cookien är giltig. Standardvärdet är root-sökvägen ('/').
 * @param {string} [domain] - Domänen för vilken cookien är giltig.
 * @param {boolean} [secure] - En boolean som anger om cookien endast ska överföras över säkra (HTTPS) anslutningar.
 * @param {string} [sameSite] - SameSite-attributet för cookien, som kan anges till "Strict", "Lax" eller "None". Standardvärdet är "Lax".
 */
export function setCookie(name, value, days, path = '/', domain, secure = false, sameSite = 'Lax') {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }

  path = path ? '; path=' + path : '; path=/';
  domain = domain ? '; domain=' + domain : '';
  secure = secure ? '; Secure' : '';
  sameSite = sameSite ? '; SameSite=' + sameSite : '; SameSite=Lax';

  document.cookie = name + '=' + encodeURIComponent(value) + expires + path + domain + secure + sameSite;
}

/**
 * Hämtar värdet på en cookie med dess namn.
 *
 * @param {string} name - Namnet på cookien att hämta.
 * @returns {string | null} Värdet på cookien eller null om cookien inte hittas.
 */
export function getCookie(name) {
  const nameEQ = encodeURIComponent(name) + '=';
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    const currentCookie = cookie.trim();

    if (currentCookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(currentCookie.substring(nameEQ.length, currentCookie.length));
    }
  }

  return null;
}
